import { render, staticRenderFns } from "./MRegisterInfoEditComp.vue?vue&type=template&id=077cf87c&scoped=true&"
import script from "./MRegisterInfoEditComp.vue?vue&type=script&lang=ts&"
export * from "./MRegisterInfoEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./MRegisterInfoEditComp.vue?vue&type=style&index=0&id=077cf87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077cf87c",
  null
  
)

export default component.exports